const SKU_IMPORT_STEP_TEST_ID = "sku-import-step";

export const setSkuImportStepTestId = (suffix: string) => `${SKU_IMPORT_STEP_TEST_ID}-${suffix}`;
